/** 国家/地区首页 inject：从 home.vue 读取已翻译文案 */
export default {
  inject: {
    vpnHomeContentRoot: { default: null },
  },
  computed: {
    homeLocale() {
      if (!this.vpnHomeContentRoot) {
        return null;
      }
      return this.vpnHomeContentRoot.vpnHomeContent || null;
    },
  },
};
